import type { ScreenName } from '@/types/navigation';
import { HeartbeatRequestActivityEnum } from '@/services/generated/Api';

const SCREEN_ACTIVITY: Partial<Record<ScreenName, HeartbeatRequestActivityEnum>> = {
  cases: HeartbeatRequestActivityEnum.ViewingCases,
  'case-details': HeartbeatRequestActivityEnum.ViewingCases,
  'case-item': HeartbeatRequestActivityEnum.ViewingCases,
  'case-roulette': HeartbeatRequestActivityEnum.OpeningCase,

  upgrade: HeartbeatRequestActivityEnum.Upgrades,
  contracts: HeartbeatRequestActivityEnum.Contracts,

  'case-battles': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-create': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-details': HeartbeatRequestActivityEnum.CaseBattles,
  'case-battle-history': HeartbeatRequestActivityEnum.CaseBattles,

  shop: HeartbeatRequestActivityEnum.Shop,
  'shop-skins': HeartbeatRequestActivityEnum.Shop,
  'shop-items': HeartbeatRequestActivityEnum.Shop,
  'shop-item': HeartbeatRequestActivityEnum.Shop,

  inventory: HeartbeatRequestActivityEnum.Inventory,
  'inventory-item': HeartbeatRequestActivityEnum.Inventory,
  'send-item': HeartbeatRequestActivityEnum.Inventory,

  packages: HeartbeatRequestActivityEnum.Topup,
  payment: HeartbeatRequestActivityEnum.Topup,

  wheel: HeartbeatRequestActivityEnum.Wheel,

  'giveaway-details': HeartbeatRequestActivityEnum.Giveaway,
  'daily-giveaway-details': HeartbeatRequestActivityEnum.Giveaway,
  'daily-giveaway-details-winners': HeartbeatRequestActivityEnum.Giveaway,
};

export function screenToActivity(screen: ScreenName): HeartbeatRequestActivityEnum {
  return SCREEN_ACTIVITY[screen] ?? HeartbeatRequestActivityEnum.Browsing;
}
